import { makeAutoObservable } from 'mobx';
import { IconNameEnum, ColorEnum } from '@app/common';
import {
    UpdatePortfolioDto,
    UpdatePortfolioDtoColorNameEnum,
    UpdatePortfolioDtoIconNameEnum,
} from '../../../../defs/api';
import { PortfolioMobxDto } from './portfolio-mobx-dto';
import { ensureIconName, ensureColorName } from '../../../../utils/ensure-enum-value';

export class UpdatePortfolioMobxDto implements Omit<UpdatePortfolioDto, 'iconName' | 'colorName'> {
    public id: string = '';

    public name = '';

    public iconName: IconNameEnum = IconNameEnum.WalletFilled;

    public colorName: ColorEnum = ColorEnum.Blue;

    public currencyCode = 'CZK';

    public isRecalculating = false;

    public selected = false;

    public includedInSummary = true;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: UpdatePortfolioDto): UpdatePortfolioMobxDto {
        const mobxDto = new UpdatePortfolioMobxDto();
        Object.assign(mobxDto, dto);

        mobxDto.iconName = ensureIconName(dto.iconName);
        mobxDto.colorName = ensureColorName(dto.colorName);

        return mobxDto;
    }

    static createFromArray(dtos: UpdatePortfolioDto[]): UpdatePortfolioMobxDto[] {
        return dtos.map((dto) => UpdatePortfolioMobxDto.create(dto));
    }

    public static createFromPortfolio(portfolio: PortfolioMobxDto): UpdatePortfolioMobxDto {
        const updatePortfolioDto = new UpdatePortfolioMobxDto();
        updatePortfolioDto.id = portfolio.id;
        updatePortfolioDto.name = portfolio.name;
        updatePortfolioDto.iconName = portfolio.iconName || IconNameEnum.WalletFilled;
        updatePortfolioDto.colorName = portfolio.colorName || ColorEnum.Blue;
        updatePortfolioDto.currencyCode = portfolio.portfolioHistoryCurrencyCode || '';
        updatePortfolioDto.includedInSummary = portfolio.includedInSummary;

        return updatePortfolioDto;
    }

    public static createEmpty(): UpdatePortfolioMobxDto {
        return new UpdatePortfolioMobxDto();
    }

    public toApiData(): UpdatePortfolioDto {
        return {
            ...this,
            iconName: this.iconName as unknown as UpdatePortfolioDtoIconNameEnum,
            colorName: this.colorName as unknown as UpdatePortfolioDtoColorNameEnum,
        };
    }
}
